export default "__VITE_ASSET__CflcDdVv__"